import * as SX from '@aibees/elephant/components/list-type-select/sx';
import { TableFilterSelectOption } from '@aibees/elephant/components/table-filter-select';
import { ElephantPresetType } from '@aibees/elephant/types';

export const CONFIG: TableFilterSelectOption[] = [
  {
    key: `${ElephantPresetType.COMPANY_SAVED_SEARCH},${ElephantPresetType.PEOPLE_SAVED_SEARCH}`,
    value: 'All Types',
  },
  {
    key: ElephantPresetType.COMPANY_SAVED_SEARCH,
    value: 'Company',
    icon: 'business',
    iconSx: SX.companyIcon,
  },
  {
    key: ElephantPresetType.PEOPLE_SAVED_SEARCH,
    value: 'People',
    icon: 'people-outline',
    iconSx: SX.contactIcon,
  },
];
